import React from "react";
import { Link } from "react-router-dom";

const Button = ({ button }) => {
  const data = button;
  const addAllClasses = ["font-bold py-2 px-4 rounded w-auto capitalize"];
  if (data.type === "primary") {
    addAllClasses.push("bg-primary hover:bg-secondary text-white ");
  } else if (data.type === "secondary") {
    addAllClasses.push("bg-primary hover:bg-secondary text-white border");
  }
  return <button className={addAllClasses.join(" ")}><Link to={button.path}>{data.label}</Link></button>;
};
export default Button;
